<template>
  <div class="prompt">
    <div class="prompt_title">{{ $t('home.prompt.title') }}</div>
    <div class="prompt_text">{{ $t('home.prompt.text1') }}</div>
    <div class="prompt_text">{{ $t('home.prompt.text2') }}</div>
    <div class="prompt_text">{{ $t('home.prompt.text3') }}</div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { defineComponent, ref, onMounted ,computed } from "vue";
  import { useI18n } from "vue-i18n";
  import { useStore } from "vuex"
  export default defineComponent({
    name: 'prompt',
    setup() {
      const { t, locale } = useI18n()
      const store = useStore()
      let lan = computed(() => store.state.lan)
      return {
        lan,
      };
    }
  })
</script>

<style scoped lang="scss">
.prompt {
  width: 1200px;
  margin: 0 auto;
  padding: 30px 40px;
  border-radius: 30px;
  box-sizing: border-box;
  background: linear-gradient(149.18deg, rgba(47, 67, 55, 0.544) 15.69%, rgba(46, 81, 60, 0.2312) 105.11%);
  .prompt_title {
    color: #fff;
    font-size: 26px;
    font-weight: 600;
    line-height: 34px;
    text-align: center;
    margin-bottom: 20px;
    letter-spacing: 0.05em;
  }
  .prompt_text {
    font-size: 14px;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 0em;
    color: rgba(255, 255, 255, 0.8);
  }
}

@media screen and (max-width: 1200px) {
  .prompt {
    width: 90%;
    .show {
      display: none;
    }
    .hide {
      display: block;
    }
  }
}
</style>